module.exports = __webpack_public_path__ + "media/images/front/brands/signature/signature_header_2-c6c0488b728d5941343665e84ee9ff57.jpg";